// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__FieldRenderers__Emersya3dViewer__root","message":"CentricUI__FieldRenderers__Emersya3dViewer__message","text":"CentricUI__FieldRenderers__Emersya3dViewer__text","actions":"CentricUI__FieldRenderers__Emersya3dViewer__actions","actionButton":"CentricUI__FieldRenderers__Emersya3dViewer__actionButton","toolbar":"CentricUI__FieldRenderers__Emersya3dViewer__toolbar","toolbarButtons":"CentricUI__FieldRenderers__Emersya3dViewer__toolbarButtons"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/Emersya3dViewer.css
// module id = 311
// module chunks = 10